import Types from 'store/actionTypes/configurationPersComn'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  filter: {}
}

const configurationPersComn = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case Types.GET_CONFIGURATION_PERS_COMNS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case Types.UPDATE_FILTER_CONFIGURATION_PERS_COMN_SUCCESSs:
      return { ...state, filter: payload }
    case Types.CLEAR_FILTER_CONFIGURATION_PERS_COMN_SUCCESS:
      return { ...state, filter: initialData.filter }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default configurationPersComn
